import { render, staticRenderFns } from "./SalOrderItemChange.vue?vue&type=template&id=67bbdb0e&scoped=true"
import script from "./SalOrderItemChange.vue?vue&type=script&lang=js"
export * from "./SalOrderItemChange.vue?vue&type=script&lang=js"
import style0 from "./SalOrderItemChange.vue?vue&type=style&index=0&id=67bbdb0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bbdb0e",
  null
  
)

export default component.exports